module.exports = __webpack_public_path__ + "img/Icon@2x.7c898316.png";